export default __webpack_public_path__ + "src/images/packages/lush-private-game-lodge/2499ec0379a63642d31dd97c92ff7f2e-1.jpg";